import { z } from 'zod'

const RuntimeConfigSchema = z.object({
  API_BASE_URL: z.string().default('/api'),
  API_MODE: z.enum(['mock', 'real']).default('mock'),
  MOCK_SCENARIO: z.enum(['empty', 'populated', 'error']).default('populated'),
  MOCK_DEVTOOLS: z.boolean().default(false),
  SENTRY_DSN: z.string().default(''),
  SENTRY_ENVIRONMENT: z.string().default('development'),
  RELEASE: z.string().default('dev'),
})

export type RuntimeConfig = z.infer<typeof RuntimeConfigSchema>

declare global {
  interface Window {
    __APP_CONFIG__?: unknown
  }
}

function readConfig(): RuntimeConfig {
  const fromWindow: object = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}
  const env = import.meta.env as Record<string, string | undefined>
  const fromEnv = {
    API_MODE: env.VITE_API_MODE,
    MOCK_SCENARIO: env.VITE_MOCK_SCENARIO,
    MOCK_DEVTOOLS: env.VITE_MOCK_DEVTOOLS === '1',
  }
  return RuntimeConfigSchema.parse({ ...fromEnv, ...fromWindow })
}

export const runtimeConfig = readConfig()
